import { cn } from '@/lib/utils'
import DashboardTile from 'app/frontend/base/components/DashboardTile'
import TeamSwitcher from '../../TeamDashboard/components/TeamSwitcher'
import dayjs from 'dayjs'
import RelativeTime from 'dayjs/plugin/relativeTime'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { useCustomDomain } from 'app/frontend/base/hooks/useCustomDomain'
import CustomDomainDashboardHeader from './CustomDomainDashboardHeader'
import EntityLinksTile from './EntityLinksTile'
import TeamSubheader, {
  useTeamMenuItems,
} from '../../TeamDashboard/components/TeamSubheader'
import Subheader from 'app/frontend/base/components/Subheader'

dayjs.extend(RelativeTime)

const CustomGuildHeader = () => {
  const { guild, teamReference } = useGuild()
  const { customDomain } = useCustomDomain()

  const uriLinkFragment = `${guild?.realm?.region.toLowerCase()}/${
    guild?.realm?.slug
  }/${guild?.slug}`

  const contentOptions: Record<string, string> = {
    guildName: guild?.name ?? '',
    teamDescription: '',
    teamName: '',
    none: '',
  }

  const title =
    contentOptions[customDomain?.headerConfig?.titleType ?? 'guildName']

  const subtitle =
    contentOptions[customDomain?.headerConfig?.subtitleType ?? 'none']
  const mainMenuContent =
    customDomain?.headerConfig?.mainMenuContent ?? 'team_switcher_and_team_menu'
  const showTeamSubheader =
    teamReference && mainMenuContent !== 'team_switcher_and_team_menu'
  const showTeamChildSubheader =
    teamReference && mainMenuContent === 'team_switcher_and_team_menu'
  const { eventsMenuItems, lootMenuItems } = useTeamMenuItems()
  const pathSegments = window.location.pathname.split('/').filter(Boolean)
  const isLootPage = pathSegments.includes('loot')
  const isEventPage =
    pathSegments.includes('events') || pathSegments.includes('plans')

  return (
    <>
      <CustomDomainDashboardHeader
        title={title}
        subtitle={subtitle}
        titleEyebrow={guild?.realm?.nameWithRegion}
        titleFooter={
          mainMenuContent === 'only_guild_menu' ? (
            <div className='h-[1.6rem] max-sm:mt-1'>
              <TeamSwitcher />
            </div>
          ) : null
        }
        uriLinkFragment={uriLinkFragment}
        renderTiles={(cardClassName) => (
          <div className='flex gap-2'>
            <DashboardTile
              className={cn(cardClassName, 'hidden sm:block')}
              innerClassName='h-8'
              title='members'
              dataPresent={true}
            >
              <div>{guild?.guildMembers || '-'}</div>
            </DashboardTile>

            <DashboardTile
              className={cn(cardClassName, 'hidden md:block')}
              innerClassName='h-8'
              title='founded'
              dataPresent={true}
            >
              <div>
                {guild?.foundedAt ? dayjs(guild.foundedAt).fromNow() : '-'}
              </div>
            </DashboardTile>

            {customDomain?.headerConfig?.hideLinks ? null : (
              <EntityLinksTile
                className={cardClassName}
                uriLinkFragment={uriLinkFragment}
              />
            )}
          </div>
        )}
      />

      {showTeamSubheader ? (
        <TeamSubheader />
      ) : showTeamChildSubheader && isLootPage ? (
        <Subheader menuItems={lootMenuItems} />
      ) : showTeamChildSubheader && isEventPage ? (
        <Subheader menuItems={eventsMenuItems} />
      ) : null}
    </>
  )
}

export default CustomGuildHeader
